import { render, staticRenderFns } from "./IdOneMrzInput.vue?vue&type=template&id=0039509e&"
import script from "./IdOneMrzInput.vue?vue&type=script&lang=ts&"
export * from "./IdOneMrzInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports